import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trimText',
  standalone: true,
})
export class TrimTextPipe implements PipeTransform {
  transform(value: string, limit: number): string {
    if (!value || typeof value !== 'string') {
      return '';
    }

    // Remove &nbsp; e tags HTML (output do p-editor)
    const withoutNbsp = value.replace(/&nbsp;/gi, ' ');
    const withoutHtml = withoutNbsp.replace(/<[^>]*>/g, '');
    const cleaned = withoutHtml.replace(/\s+/g, ' ').trim();

    if (cleaned.length <= limit) {
      return cleaned;
    }

    return cleaned.substring(0, limit) + '...';
  }
}
